"use client"

import Image from "next/image"

const DesktopExploreTheWorld = ({ onClick }: any) => {
  return (
    <div className="relative mx-auto mb-[120px] hidden w-[1360px] max-w-full flex-col items-center overflow-hidden rounded-[28px] bg-white pt-[48px] lg_flex">
      <h2 className="mb-[16px] text-[48px] font-[700] leading-[58px] text-title">
        Explore the avian world with loved ones!
      </h2>
      <p className="mb-[48px] text-[24px] font-[700] leading-[28px] text-[#3E3E3E]">
        No limits on the number of people who can access these abilities.
      </p>
      <Image
        width={1368}
        height={760}
        alt=""
        layout="responsive"
        className="w-full cursor-pointer"
        src="/images/explore-the-world.webp"
      />
      <div className="absolute bottom-[64px] flex w-full justify-center">
        <div
          onClick={onClick}
          className="hover:border-[#FFB100] w-[320px] cursor-pointer rounded-[24px] border-[3px] border-[#EE6C4D] bg-[#EE6C4D] text-center text-[36px] font-[700] leading-[64px] text-white"
        >
          Order Now!
        </div>
      </div>
    </div>
  )
}

export default DesktopExploreTheWorld
